@if (isMapScriptLoaded() && markers() && markers().length > 0) {
  <div class="google-map">
    <google-map
      #vardenMap
      (boundsChanged)="onBoundsChanged()"
      (mapClick)="onMapClick($event)"
      (mapInitialized)="onMapInitialized($event)"
      [options]="options"
      height="100%"
      width="100%"
    >
      <map-marker-clusterer
        [imagePath]="
        'https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m'
      "
      >
        @for (marker of markers(); track marker.id) {
          <map-marker
            #vardenMarker="mapMarker"
            (mapClick)="onMarkerClick(vardenMarker, marker)"
            [options]="marker.options"
            [position]="marker.location"
            [title]="marker.title"
          >
          </map-marker>
        }

      </map-marker-clusterer>
      <map-info-window
        (closeclick)="closeInfoWindow()"
        [innerHTML]="infoContent()"
      ></map-info-window>
    </google-map>
  </div>
}

<app-ui-icon (click)="closeDialog()" class="google-map-dialog-close-btn" color="var(--grey-1)" name="close"
             size="lg"></app-ui-icon>

@if (isFirstMarkerLoaded() === true && (!markers() || markers().length === 0)) {
  <div class="info-container">
    Det finns inga objekt på kartan.
  </div>
}

